import { EmptyDashboardComponent } from "./EmptyDashboardComponent";
import { CalendarDays } from "lucide-react";

export function UpcomingMealsComponent({
  upcomingMeals,
  onClickParent,
  onClickChild,
}) {
  return (
    <div
      className="lg:col-span-3 bg-white rounded-lg border border-gray-200 p-6"
      onClick={onClickParent}
      style={{ cursor: "pointer" }}
    >
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        This Week at a Glance
      </h2>
      {upcomingMeals.length === 0 ? (
        <EmptyDashboardComponent icon={CalendarDays} />
      ) : (
        <div className="space-y-4">
          {upcomingMeals.map((meal, index) => (
            <div
              key={index}
              className="flex items-center gap-4 p-3 rounded-lg hover:bg-gray-50 transition-colors"
              onClick={onClickChild}
              style={{ cursor: "pointer" }}
            >
              <div className="w-16 h-16 rounded-lg bg-gradient-to-br from-orange-400 to-pink-400 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs font-medium text-gray-500 uppercase">
                    {meal.day}
                  </span>
                  <span className="text-xs text-gray-400">•</span>
                  <span className="text-xs text-gray-500">{meal.time}</span>
                </div>
                <p className="text-sm font-medium text-gray-900">{meal.meal}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
